module.exports = __webpack_public_path__ + "static/media/background-consulting.18094186.jpg";